import { render, staticRenderFns } from "./new-update.vue?vue&type=template&id=a4bb20d2&scoped=true&"
import script from "./new-update.vue?vue&type=script&lang=js&"
export * from "./new-update.vue?vue&type=script&lang=js&"
import style0 from "./new-update.vue?vue&type=style&index=0&id=a4bb20d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bb20d2",
  null
  
)

export default component.exports